export default interface ProductType {
    code: string;
    description: string;
    orderNumber: string;
}

export function getEmptyProductType(): ProductType {
    return {
        code: "",
        description: "",
        orderNumber: ""
    }
}

export function validateProductType(productType: ProductType): Map<string, string> {
    const errors = new Map<string, string>();

    if (productType.code === undefined || productType.code === "") {
        errors.set("code", "The code field is required.");
    }

    if (productType.description === undefined || productType.description === "") {
        errors.set("description", "The description field is required.");
    }

    if (productType.orderNumber === undefined || productType.orderNumber === "") {
        errors.set("orderNumber", "The order number field is required.");
    }

    return errors;
}